module.exports = __webpack_public_path__ + "img/logo_excelso.31394287.png";